import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
      isDarkMode: false,
      userInfo: {
        username: 'My Dear Friend',
      },
    };
  },
  mutations: {
    SET_DARK_MODE(state, value) {
      state.isDarkMode = value;
    },
    UPDATE_USER_INFO(state, payload) {
      state.userInfo = { ...state.userInfo, ...payload };
    },
  },
  actions: {
    toggleDarkMode({ commit, state }) {
      const newValue = !state.isDarkMode;
      commit('SET_DARK_MODE', newValue);
      localStorage.setItem('isDarkMode', JSON.stringify(newValue));
      if (newValue) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    },
    initDarkMode({ commit }) {
      const stored = localStorage.getItem('isDarkMode');
      let isDark;
      if (stored !== null) {
        isDark = JSON.parse(stored);
      } else {
        isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      }
      commit('SET_DARK_MODE', isDark);
      if (isDark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    },
    updateUserInfo({ commit }, userInfo) {
      commit('UPDATE_USER_INFO', userInfo);
    },
  },
});

export default store;
